<template>
    <div class="success-example">
        <header-common @popupHandle="popupHandle" :isFixed="isFixed"></header-common>
        <div class="main-content" style="min-height: 500px;">
            <div class="main-content-box">
                <!-- <div class="success">成功案例</div> -->
                <div class="box">
                    <div class="content-box-title">成功案例</div>
                    <div class="content-box-span">"医院信息服务" 的贴心管家</div>
                </div>
            </div>
            <div class="medal-box">
                <div class="medal" v-for="(item,index) in arr" :key="index">
                 <img :src='item.url'/>
                <div>{{item.value}}</div>
                </div>
            </div>
        </div>
        <footer-common :isShowTopBtn="isShowTopBtn"> </footer-common>
    </div>
</template>

<script>

import headerCommon from '../common/headerCommon';
import footerCommon from '../common/footerCommon';
export default {
    name: "successExample",
    data () {
        return {
            isShowTopBtn: false,
            isFixed: false,
            arr:[
                {
                    url:require("../../assets/images/webSite/exam_1.png"),
                    value:"江苏省中医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_2.png"),
                    value:"江苏省中西医结合医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_3.png"),
                    value:"江苏省肿瘤医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_4.png"),
                    value:"南京鼓楼医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_5.png"),
                    value:"南京市儿童医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_6.png"),
                    value:"上海市同济医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_7.png"),
                    value:"徐州儿童医院"
                },
                {
                    url:require("../../assets/images/webSite/exam_8.png"),
                    value:"南京市溧水区人民医院"
                }
            ]
        };
    },
    components: {
        headerCommon,
        footerCommon
    },
    methods: {
        handleScroll () {
            let that = this;
            this.$nextTick(()=>{
                // 设备/屏幕高度
                let scrollTop = document.documentElement.scrollTop; // div 到头部的距离
                if (scrollTop >0) {
                    that.isFixed = true;
                    that.isShowTopBtn = true;
                } else {
                    that.isFixed = false;
                    that.isShowTopBtn = false;
                }
            });
        },
        popupHandle (){}
    },
    mounted() {
        window.addEventListener('scroll',this.handleScroll);
    }
};
</script>

<style scoped lang="less">
.success-example{
  @media screen and (min-width: 1200px) {
    .main-content{
            margin: auto;
        padding-top: 60px;
      .main-content-box{
        // .success{
        //   display: none;
        // }
       width: 100%;
       height: 435px;
       background: url(../../assets/images/webSite/success_exam_banner.png)no-repeat;
       position: relative;
       background-size: 100% 100%;
       .box{
           width: 1024px;
           height: 200px;
           margin-left: -512px;
           position: absolute;
           top: 132px;
           left: 50%;
           text-align: left;
         .content-box-title{
             font-size: 36px;
             font-weight: 900;
             color: #ffffff;
              font-family: "MicrosoftYaHei-Bold";
              line-height:60px;
         }
         .content-box-span{
          font-size:16px;
          color: #ffffff;
          font-family: "MicrosoftYaHei-Bold";
          line-height:40px
         }
       }
      }
    .medal-box{
      display: flex;
      justify-content: center;
        width: 70%;
        flex-wrap: wrap;
      // margin: 60px 0;
      margin-top: 20px;
      margin-left: 15%;
      margin-bottom: 125px;
      .medal{
            margin: 30px 69px;
            img{
              margin-bottom: 8px;
            }
            div{
              font-size: 14px;
              font-family:" MicrosoftYaHei";
              color: #7e7e7e;
            }
      }
    }
    }
      .footer-style{
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
      }
  }
  @media screen and (max-width:1199px) {
    .main-content{
        padding-top: 60px;
      .main-content-box{
        position: relative;
        // .success{
        //   display:block;
        //   font-size: 20px;
        //   font-family:" MicrosoftYaHei";
        //   color: #00a0e9;
        //   position: fixed;
        //   z-index:222222;
        //   top:15px;
        //   left:46px
        // }
        width: 100%;
        height: 375px;
        background: url(../../assets/images/webSite/success_exam.png)no-repeat;
        background-size:  100%  100%;
        // background-size:cover;
       overflow: hidden;
        .box{
          height: 100%;
          margin-top: 120px;
          .content-box-title{
              font-size: 2.5rem;
              color: #ffffff;
               font-family: "MicrosoftYaHei-Bold";
               font-weight: 900;
               line-height:60px
          }
          .content-box-span{
           font-size:1.25rem;
           color: #ffffff;
           font-family: "MicrosoftYaHei";
           line-height:36px
          }
      }
    }
    .medal-box{
      display: flex;
      flex-wrap: wrap;
      width:90%;
      // justify-content: center;
      margin: 30px auto 30px auto;
      .medal{
        width:50%;
            margin:30px 0;
            img{
                width: 50%;
              margin-bottom: 10px;
            }
            div{
              font-size: 1em;
              font-family:" MicrosoftYaHei";
              color: #7e7e7e;
            }
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/successExample/example.vue